// extracted by mini-css-extract-plugin
export default {"target":"TZSrO","container":"lAscE","title":"jD299","text":"SXNoa"};